import listActions from 'src/modules/puesto/list/puestoListActions';
import PuestoService from 'src/modules/puesto/puestoService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/history';
import Message from 'src/view/shared/message';

const prefix = 'PUESTO_DESTROY';

const puestoDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: puestoDestroyActions.DESTROY_STARTED,
      });

      await PuestoService.destroyAll([id]);

      dispatch({
        type: puestoDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.puesto.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/puesto');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: puestoDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: puestoDestroyActions.DESTROY_ALL_STARTED,
      });

      await PuestoService.destroyAll(ids);

      dispatch({
        type: puestoDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.puesto.destroyAll.success'),
      );

      getHistory().push('/puesto');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: puestoDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default puestoDestroyActions;
